import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class UserConfirmationService {

  constructor(private _http: HttpClient) { }

  get(cache: string) {
    return this._http.get<any>('api/s/userConfirmation/get/' + cache);
  }

  save(user: any, confirmationId: number) {
    return this._http.post<any>('api/s/userConfirmation/save/' + confirmationId, user);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/services/user-confirmation.service.ts